import { Provider, type Account } from '@repo/api-gw-sdk';

import { useRestoreAccounts } from '@/app/(dashboard)/settings/restore-accounts/useRestoreAccounts';
import { createCloudProviderCondition } from '@/components/cloudProviders/createCloudProviderCondition';
import { Loader } from '@/components/shared/loader';

import { getMrapPolicyJson } from './byovPolicyUtils';

import { CopyableCode } from '../shared/copyableCode';

export const MrapCopyablePolicy = ({
  mrapAlias,
  vaultAccount,
}: {
  mrapAlias: string;
  vaultAccount: Account | undefined;
}) => {
  const { data: restoreAccountsBody, isLoading } = useRestoreAccounts(
    createCloudProviderCondition([Provider.Aws])
  );

  if (isLoading) {
    return <Loader />;
  }

  const restoreAccounts = restoreAccountsBody?.accounts ?? [];
  const policy = getMrapPolicyJson(mrapAlias, vaultAccount, restoreAccounts);

  return (
    <CopyableCode
      title='mrap-policy.json'
      code={policy}
      maxHeight='320px'
      blur={!mrapAlias || restoreAccounts.length === 0}
    />
  );
};
